export const EMPTY_VALUE = '""';

export const isValueEmpty = (value: any) => {
    return value === null || value === undefined || value === '' || value === EMPTY_VALUE;
};

export const isColumnEmpty = (data: any[], columnName: string) => {
    return data.every((row) => {
        const value = row[columnName];
        return isValueEmpty(value);
    });
};

export const isRowEmpty = (row: any[]) => {
    return row.every(
        (value) => isValueEmpty(value) || (typeof value === 'string' && value.trim() === ''),
    );
};

export const findEmptyColumns = (data: any[], columnsToRemove: string[] = []) => {
    if (data.length === 0) return [];

    const columnNames = Object.keys(data[0]);
    return columnNames.filter(
        (column) => column && !columnsToRemove.includes(column) && isColumnEmpty(data, column),
    );
};

export const removeColumns = <T extends Record<string, unknown>>(
    data: T[],
    columnsToRemove: string[],
): T[] => {
    return data.map((row) => {
        const newRow = { ...row };
        columnsToRemove.forEach((column) => {
            delete newRow[column];
        });
        return newRow as T;
    });
};
